import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'
import LabelComponent from 'features/expedientes/components/LabelComponent'
import { useContext, useEffect, useRef, useState } from 'react'
import { numericValidation } from '../../libs/FieldResquestValidator'
import { ExpedientesContext } from '../../providers/ExpedientesProvider'

function TextComponent({ columna, error }) {
  const {
    campos_expediente,
    setCampoExpediente,
    setCampoCargando,
    setCampoError,
    setLoadingCampos,
    validaCampoExpediente,
  } = useContext(ExpedientesContext)

  const inputReference = useRef(null)

  const campos = campos_expediente
  const campo = campos.filter((c) => c.columna === columna)[0]

  const valor = campo.valor

  const [value, setValue] = useState(campo.valor)

  useEffect(() => {
    setValue(valor)
    if (valor && campo.validacion === 'S') {
      setCampoCargando(campo.columna, true)
    }
  }, [valor])

  const handleError = (open, message, columna) => {
    if (message) {
      setCampoError(columna, open)
    }
  }

  const handleBlur = (e) => {
    try {
      let value = e.target.value

      if (campo.tipo_input === 'number') {
        value = numericValidation(campo, e.target.value, true)
      }

      if (campo.validacion === 'S' && value) setCampoCargando(campo.columna, true)

      setCampoExpediente(campo, value, campo.validacion === 'S')

      handleError(false, '', campo.columna)
    } catch (error) {
      handleError(true, error.message, campo.columna)
      inputReference.current.focus()
      e.currentTarget.focus()
      e.target.focus()
    }
  }

  const handleNumericChange = (e) => {
    try {
      const masked_value = numericValidation(campo, e.target.value)
      setValue(masked_value)
      handleError(false, '', campo.columna)
    } catch (e) {
      handleError(true, e.message, campo.columna)
    }
  }

  if (campo && campo.oculto !== 'S') {
    const numerico = (
      <Box key={campo.columna}>
        <Box sx={{ display: 'flex' }}>
          <LabelComponent text={campo.literal} />
          {error && (
            <LabelComponent
              text={'* ' + error}
              sx={{
                color: error ? 'error.main' : 'inherit',
                ml: 1,
                fontSize: '0.8rem',
                fontWeight: '400',
              }}
            />
          )}
        </Box>
        <TextField
          ref={inputReference}
          key={campo.columna}
          id={campo.columna}
          placeholder={campo.literal}
          variant="standard"
          type="tel"
          required={campo.obligatorio === 'S'}
          fullWidth
          value={value ?? ''}
          onChange={handleNumericChange}
          onBlur={handleBlur}
          disabled={campo.desactivado === 'S'}
          slotProps={{
            htmlInput: {
              maxLength: campo.tamano_max,
              inputMode: 'decimal',
              pattern: '[0-9]*',
            },
            inputLabel: {
              shrink: value ? true : false,
            },
            input: {
              startAdornment: campo.cargando ? <CircularProgress size={20} /> : null,
            },
          }}
          error={error ? true : false}
          sx={{ border: error ? '1px solid red' : 'none', borderRadius: error ? '15px' : 'none' }}
        />
      </Box>
    )
    const alfanumerico = (
      <Box>
        <Box sx={{ display: 'flex' }}>
          <LabelComponent text={campo.literal} />
          {error && (
            <LabelComponent
              text={'* ' + error}
              sx={{
                color: error ? 'error.main' : 'inherit',
                ml: 2,
                fontSize: '0.8rem',
                fontWeight: '400',
              }}
            />
          )}
        </Box>
        <TextField
          ref={inputReference}
          key={campo.columna}
          id={campo.columna}
          placeholder={campo.literal}
          variant="standard"
          required={campo.obligatorio === 'S'}
          fullWidth
          slotProps={{
            htmlInput: {
              maxLength: campo.tamano_max,
            },
            inputLabel: {
              shrink: value ? true : false,
            },
            input: {
              startAdornment: campo.cargando ? <CircularProgress size={20} /> : null,
            },
          }}
          value={value ?? ''}
          onChange={(event) => {
            setValue(event.target.value)
          }}
          onBlur={handleBlur}
          disabled={campo.desactivado === 'S'}
          error={error ? true : false}
          sx={{ border: error ? '1px solid red' : 'none', borderRadius: error ? '15px' : 'none' }}
        />
      </Box>
    )
    const textArea = (
      <Box>
        <Box sx={{ display: 'flex' }}>
          <LabelComponent text={campo.literal} />
          {error && (
            <LabelComponent
              text={'* ' + error}
              sx={{
                color: error ? 'error.main' : 'inherit',
                ml: 2,
                fontSize: '0.8rem',
                fontWeight: '400',
              }}
            />
          )}
        </Box>
        <TextField
          ref={inputReference}
          key={campo.columna}
          id={campo.columna}
          placeholder={campo.literal}
          variant="standard"
          required={campo.obligatorio === 'S'}
          fullWidth
          multiline
          rows={4}
          value={value ?? ''}
          onChange={(event) => {
            setValue(event.target.value)
          }}
          onBlur={handleBlur}
          disabled={campo.desactivado === 'S'}
          slotProps={{
            htmlInput: {
              maxLength: campo.tamano_max,
            },
            inputLabel: {
              shrink: value ? true : false,
            },
            input: {
              startAdornment: campo.cargando ? <CircularProgress size={20} /> : null,
            },
          }}
          error={error ? true : false}
          sx={{ border: error ? '1px solid red' : 'none', borderRadius: error ? '15px' : 'none' }}
        />
      </Box>
    )

    if (campo.tipo_input === 'number') {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: campo.ancho ? campo.ancho + '%' : '100%',
          }}
        >
          {numerico}
        </Box>
      )
    } else if (Number(campo.tamano_max) <= 100) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: campo.ancho ? campo.ancho + '%' : '100%',
          }}
        >
          {alfanumerico}
        </Box>
      )
    } else {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: campo.ancho ? campo.ancho + '%' : '100%',
          }}
        >
          {textArea}
        </Box>
      )
    }
  }
}

export default TextComponent
